import React, { createContext, useContext } from 'react';
import { container, ServiceContainer } from './container';

/**
 * サービスコンテナのコンテキスト
 */
export const ServiceContext = createContext<ServiceContainer | null>(null);

/**
 * サービスプロバイダー
 */
export const ServiceProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // SSR時はnullを渡す（ブラウザでのみServiceContainerを初期化）
  const value = typeof window === 'undefined' ? null : container;

  return (
    <ServiceContext.Provider value={value}>{children}</ServiceContext.Provider>
  );
};

/**
 * サービスコンテナを取得するフック
 */
export function useServices(): ServiceContainer {
  const context = useContext(ServiceContext);

  // SSR時はエラーを出さない
  if (typeof window === 'undefined') {
    return {} as ServiceContainer;
  }

  if (!context) {
    throw new Error('useServices must be used within ServiceProvider');
  }

  return context;
}
